import React from 'react'
import logo from '../assets/images/g8.webp'
import message from '../assets/images/Message.webp'
import call from '../assets/images/Call.webp'
import location from '../assets/images/location.webp'
import { Link } from 'react-router-dom'

const Footer = () => {
  return (
    <div>
      <section className='bg-black py-3'>
        <div className='container'>
          <div className='mt-5 container'>
            <div className='row overallrow webfooter'>
              <div className='col-lg-12'>
                <div className='row '>
                  <div className='col-lg-3  paddingicon'>
                    <img src={logo} className='footermargin' alt='' />
                    <div className='mt-3 d-flex gap-2 justify-content-center text-align-center '>
                      <i class="fa-brands fa-x-twitter fonticon rounded-circle"></i>
                      <i class="fa-brands fa-facebook-f fonticon roundbook"></i>
                      <i class="fa-brands fa-instagram fonticon rounded-circle"></i>
                    </div>
                  </div>
                  <div className='col-lg-9'>
                    <div className='row'>
                      <div className='col-lg-5'>
                        <div className='row Trading padding-footer1'>
                          <Link to="/?id=Home" className='col-lg-3 footerlink'>Home
                          </Link>
                          <Link to="/?id=Services" className='col-lg-3 footerlink'>Services
                          </Link>
                          <Link to="/?id=AboutUs" className='col-lg-3 footerlink'>About
                          </Link>
                          <Link to="/?id=Contactus" className='col-lg-3 footerlink'>Contact
                          </Link>
                        </div>
                      </div>
                      <div className='col-lg-7 Trading padding-footer2'>
                        <div className='row footergap'>

                          <Link to={`/Service/forwarding`} className='col-lg-4 footerlink forwardpadding'>
                            Freight Forwarding
                          </Link>
                          <Link to={`/Service/inspection`} className='col-lg-4 footerlink'>
                            Vessel Inspection               </Link>
                          <Link to={`/Service/trading`} className='col-lg-4 footerlink'>
                            General Trading
                          </Link>

                        </div>


                      </div>
                      <div className='row py-5 Trading1'>
                        <div className='col-lg-4 contact-footer'>
                          <img src={message} className='' alt="message" />
                          <a className="text-decoration-none text-white" href="mailto:info@northwoodshippingservices.com">
                           info@northwoodshippingservices.com
                          </a>
                                    </div>
                        <div className='col-lg-4 contact-footer'>
                          <img src={call} className='' alt="call" />
                          +971506062702 / +971506063755
                        </div>
                        <div className='col-lg-4 contact-footer1'>
                          <div className='locationpb'>
                            <img src={location} className='' alt="location" />
                          </div>
                          Meydan Grandstand, 6th floor,<br /> Meydan Road, Nad Al Sheba,<br />Dubai, United Arab Emirates
                        </div>

                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>

            {/* tabsection */}
 <div className='row overallrow tabfooter'>
              <div className='col-lg-12'>
                <div className='row '>
                  <div className='col-lg-3  paddingicon'>
                    <img src={logo} className='footermargin' alt='' />
                    <div className='mt-3 d-flex gap-2 justify-content-center text-align-center '>
                      <i class="fa-brands fa-x-twitter fonticon rounded-circle"></i>
                      <i class="fa-brands fa-facebook-f fonticon roundbook"></i>
                      <i class="fa-brands fa-instagram fonticon rounded-circle"></i>
                    </div>
                  </div>
                  <div className='col-lg-9'>
                    <div className='row'>
                      <div className='col-lg-5 col-md-5'>
                        <div className='d-flex Trading padding-footer1'>
                          {/* <Link to="/?id=Home" className="text-decoration-none"> */}
                          <Link to="/?id=Home" className='col-lg-3 footerlink'>Home
                          </Link>
                          {/* </Link> */}
                          <Link to="/?id=About" className='col-lg-3 footerlink'>About
                          </Link>
                          <Link to="/Serviceforwarding" className='col-lg-3 footerlink'>Services
                          </Link>
                          <Link to="/?id=Contactus" className='col-lg-3 footerlink'>Contact
                          </Link>
                        </div>
                      </div>
                      <div className='col-lg-7 col-md-7 Trading padding-footer2
'>
                        <div className='d-flex footergap'>

                          <Link to="/Serviceforwarding" className='col-lg-4 footerlink'>
                            Freight Forwarding
                          </Link>
                          <Link to="/Serviceinspection" className='col-lg-4 footerlink'>
                            Vessel Inspection               </Link>
                          <Link to="/ServiceTrading" className='col-lg-4 footerlink'>
                            General Trading
                          </Link>

                        </div>


                      </div>
                    <div className='row py-5 Trading1'>
                      <div className='col-md-6'>
                        <div className=''>
                      <div className='contact-footer'>
                            <img src={message} className='' alt="message" />
                            info@northwoodshippingservices.com          
                              </div>
                              <div className='contact-footer'>
                            <img src={call} className='' alt="call" />
                            +971506062702 / +971506063755
                          </div>
                          </div>
                      </div>
                      <div className='col-md-6 Trading1 contact-footer1'>
                      <div className='locationpb'>
                            <img src={location} className='' alt="location" />
                          </div>
                          Meydan Grandstand, 6th floor,<br /> Meydan Road, Nad Al Sheba,<br />Dubai, United Arab Emirates

                      </div>

                    </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='py-3 copyright'>
            <div>
              Copyright <span><i class="fa-regular fa-copyright"></i></span> Northwood
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Footer
